import { Flame, Thermometer, Snowflake } from 'lucide-react';

export const STAGES = [
  { key: 'new', label: 'New', color: '#3B82F6', bg: '#EFF6FF' },
  { key: 'contacted', label: 'Contacted', color: '#8B5CF6', bg: '#F5F3FF' },
  { key: 'quoted', label: 'Quoted', color: '#D4870A', bg: '#FFF8ED' },
  { key: 'negotiating', label: 'Negotiating', color: '#F59E0B', bg: '#FFFBEB' },
  { key: 'won', label: 'Won', color: '#10B981', bg: '#ECFDF5' },
  { key: 'lost', label: 'Lost', color: '#EF4444', bg: '#FEF2F2' },
];

export const PRIORITIES = [
  { key: 'hot', label: 'Hot Lead', icon: Flame, color: '#EF4444', bg: '#FEF2F2' },
  { key: 'warm', label: 'Warm', icon: Thermometer, color: '#F59E0B', bg: '#FFFBEB' },
  { key: 'cold', label: 'Cold', icon: Snowflake, color: '#3B82F6', bg: '#EFF6FF' },
];

export const todayISO = () => new Date().toISOString().split('T')[0];

export const findStage = (key) => STAGES.find(s => s.key === (key || 'new')) || STAGES[0];

export const findPriority = (key) => PRIORITIES.find(p => p.key === key);

export const isOverdue = (inq, today) =>
  Boolean(inq.follow_up_date) && inq.follow_up_date <= today && !['won', 'lost'].includes(inq.stage);
